import types from './types';

export const setApiCallPendingStatus = (type, status, errorStatus) => ({
	type: types.SET_API_CALL_PENDING,
	apiCall: type,
	payload: status,
	errorStatus
});

export const setApiCallError = (type, error) => ({
	type: types.SET_API_CALL_ERROR,
	apiCall: type,
	payload: error
});

export const resetAllErrors = () => ({
	type: types.RESET_ALL_ERRORS
});
